import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

export interface customerUserSubtotal {
  customerUserCount: number
}
const userMgmtCustomerApi = createAggrApiInstance(aggr.UserMgmtCustomerApi)

export const queryCustomerUser = async (reqData: aggr.UserMgmtQueryCustomerUserRq) => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerQuerycustomerusers(reqData))
  return res
}

export const queryCustomerUserSubtotal = async (reqData: aggr.UserMgmtQueryCustomerUserSubtotalRq) => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerQuerycustomersubtotal(reqData))
  return res
}

export const queryCurrentCustomerOwnedCompany = async (term: string) => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerQuerycurrentuserownedcompanies(term))
  return res
}

export const deleteCustomerUser = async (reqData: aggr.UserMgmtDeleteCustomerAccount) => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerDeletecustomeraccount(reqData))
  return res
}

export const queryCustomerUserRegistrationLink = async (reqData: aggr.UserMgmtGenerateCustomerRegistrationLinkRq) => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerQuerycurrentusercustomerregistrationlink(reqData))
  return res
}

export const generateCustomerRegistrationLink = async (reqData: aggr.UserMgmtGenerateCustomerRegistrationLinkRq) => {
  const res = await handleApiStatus(() =>
    userMgmtCustomerApi.customerGeneratecurrentusercustomerregistrationlink(reqData)
  )
  return res
}

export const deleteCurrentUserCustomerRegistrationLink = async (
  reqData: aggr.UserMgmtGenerateCustomerRegistrationLinkRq
) => {
  const res = await handleApiStatus(() =>
    userMgmtCustomerApi.customerDeletecurrentusercustomerregistrationlink(reqData)
  )
  return res
}

export const sendCustomerRegistrationInvitation = async (
  reqData: aggr.UserMgmtSendCustomerRegistrationInvitationRq
) => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerSendcustomerregistrationinvitation(reqData))
  return res
}

export const verifyCurrentUserAsCompanyContact = async (companyUuid: string) => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerVerifycurrentuserascompanycontact(companyUuid))
  return res
}

export const getPendingCustomerInvitationCount = async () => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerGetcurrentuserpendingcustomerinvitationcount())
  return res
}

export const resendAllCustomerStaffInvitations = async () => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerResendcurrentuserallcustomerpendinginvitations())
  return res
}

export const exportAll = async (reqData: aggr.UserMgmtCustomerExportAllRq) => {
  const res = await handleApiStatus<any>(() => userMgmtCustomerApi.customerExportall(reqData))
  return res
}

export const exportSelected = async (reqData: aggr.UserMgmtCustomerExportSelectedRq) => {
  const res = await handleApiStatus<any>(() => userMgmtCustomerApi.customerExportselected(reqData))
  return res
}

export const removeAllPermission = async (reqData: aggr.UserMgmtCustomerRemoveAllPermissionRq) => {
  const res = await handleApiStatus(() => userMgmtCustomerApi.customerRemoveallpermission(reqData))
  return res
}
